import { Injectable } from '@angular/core';
import { Globals } from '@app/shared/globals/globals';
import { DateUtils } from '@app/shared/utils/date.utils';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { Observable, firstValueFrom } from 'rxjs';
import { ProfileDetailsAPIService } from '../../api/profile-details/profile-details-api.service';
import { SettingsMessages } from '../../locale/settings.messages';
import { ProfileDetailsDto } from '../../model/profile-details.model';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

const WRITE_KEY = 'write';

@Injectable()
export class ProfileDetailsBusinessService {

  // A write already in flight coalesces a duplicate call onto the same promise (see InFlightRegistry)
  // rather than rejecting it, which previously surfaced as an unhandled rejection (Sentry FRONTEND-3HT).
  private writes = new InFlightRegistry();

  constructor(
    private profileDetailsAPIService: ProfileDetailsAPIService,
    private notifyUtils: NotifyUtils,
    public globals: Globals
  ) { }

  get(): Observable<ProfileDetailsDto> {
    return this.profileDetailsAPIService.get();
  }

  update(userProfileDetails: ProfileDetailsDto): Promise<ProfileDetailsDto> {
    userProfileDetails.dateOfBirth = DateUtils.setTimezoneToUTCButKeepDate(userProfileDetails.dateOfBirth);

    return this.writes.run(WRITE_KEY, () =>
      firstValueFrom(this.profileDetailsAPIService.update(userProfileDetails))
        .then(res => {
          this.notifyUtils.notify(SettingsMessages.SUCCESS_PROFILE_UPDATED);
          this.globals.user.description = res.description;
          this.globals.user.gender = res.gender;
          this.globals.user.dateOfBirth = res.dateOfBirth;
          this.globals.user.birthdayReminder = res.birthdayReminder;
          return res;
        })
    );
  }

}
